import { ElementState, Preview } from "@creatomate/preview";
import createElement from "components/stories/video-studio/utils/creatomate/createElement";
import createSubtitleElement from "./createSubtitleElement";

const createSection = async (
  preview: Preview,
  text: string,
  index: number,
  startTime: number,
  endTime: number,
  newTrack?: number,
  organization?: string,
  element?: ElementState,
  burnSubtitles?: boolean
): Promise<string | undefined> => {
  const subtitleProperties = createSubtitleElement(
    text, index, startTime, endTime, newTrack, organization, element, burnSubtitles
  );

  await createElement(subtitleProperties, preview, false);
  return subtitleProperties.id;
};

export default createSection;
